'use strict';
define([], function () {

    return {
        templateUrl: 'app/modules/seospider/exam/analysis/components/analysis-radar/analysis-radar.html',
        bindings: {
            loading: '<',
            report:'<',
            data: '<',
            compactLabels: '<',
            /* The workspace renders this title in the card head instead. */
            hideTitle: '<'
        },
        controller: ['$scope', '$rootScope', '$translate', function ($scope, $rootScope, $translate) {
            var vm = $scope;
            var ctrl=this;
            vm.chartLabels = [];
            vm.chartData = [[]];
            vm.chartColors;


            vm.chartOptions = {
                maintainAspectRatio: true,
                scale: {
                    ticks: {
                        display: false,
                        min: 0, // minimum value
                        max: 100, // maximum value
                        fixedStepSize: 10
                    },
                    pointLabels: {
                        /* Axis labels ("Base", "Social"…) were 8px and hard to read. */
                        fontSize: 11,
                        fontColor: '#3f3f46'
                    },
                },
                elements: {
                    line: {
                        borderWidth: 2,
                        stepped: false
                    },
                    point: {
                        radius: 3,
                        hitRadius: 6,
                        hoverRadius: 4
                    }
                },
                defaultFontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                legend: {
                    display: false
                }
            };

            var reportCategoryKeys = [
                'seospider.base',
                'seospider.content',
                'seospider.structure',
                'seospider.duplicated',
                'seospider.social'
            ];
            var translatedLabels = reportCategoryKeys.map(function (key) {
                return $translate.instant(key);
            });

            vm.textColorClass = function (score) {
                if (score == null || score < 0)
                    return 'blue-text';
                if (score >= 75)
                    return 'green-text';
                else if (score >= 50)
                    return 'text-darken-1 orange-text';
                else
                    return 'red-text';

            };

            function includesAeo(report) {
                return !!(report && report.aeo && typeof report.aeo.score === 'number');
            }

            function labelsFor(report) {
                return translatedLabels.concat(includesAeo(report) ? ['AI'] : []);
            }

            vm.chartLabels = labelsFor(null);

            $rootScope.$on("languageChanged", function () {
                $translate(reportCategoryKeys).then(function (translations) {
                    translatedLabels = reportCategoryKeys.map(function (key) {
                        return translations[key];
                    });
                    vm.chartLabels = labelsFor(vm.report);
                });
            });
            function setData(){
                vm.data = ctrl.data;
                vm.chartOptions.scale.pointLabels.fontSize = ctrl.compactLabels ? 9 : 11;
                if(typeof ctrl.report === 'string'){
                    try{
                        ctrl.report=JSON.parse(ctrl.report);
                    }catch(err){
                        console.log(err);
                        ctrl.report={base:0,content:0,structure:0,duplicated:0,social:0};
                    }
                }
                vm.report = ctrl.report;
                vm.loading = ctrl.loading;
                
                if (!vm.report){
                    vm.loading=true;
                }

                var hasAeo = includesAeo(vm.report);
                var labels = labelsFor(vm.report);
                var darkMode = document.documentElement.getAttribute('data-theme') === 'dark';
                vm.chartLabels = labels;
                vm.chartOptions.scale.pointLabels.fontColor = vm.loading
                    ? (darkMode ? '#71717a' : '#d1d1d6')
                    : (darkMode ? '#d4d4d8' : '#3f3f46');
                vm.chartOptions.scale.gridLines = {
                    color: darkMode ? 'rgba(255, 255, 255, .13)' : 'rgba(63, 63, 70, .12)',
                    lineWidth: 1
                };
                vm.chartOptions.scale.angleLines = {
                    color: darkMode ? 'rgba(255, 255, 255, .13)' : 'rgba(63, 63, 70, .12)',
                    lineWidth: 1
                };

                if (vm.loading) {
                    vm.chartData = [labels.map(function () { return 0; })];
                    vm.chartColors = ['#dddddd'];
                } else {
                    var values = [
                        getScoreByCategory(vm.report.base),
                        getScoreByCategory(vm.report.content),
                        getScoreByCategory(vm.report.structure),
                        getScoreByCategory(vm.report.duplicated),
                        getScoreByCategory(vm.report.social)
                    ];
                    var score;
                    if (hasAeo) {
                        values.push(getScoreByCategory(vm.report.aeo));
                        score = values[0] * 0.15
                            + values[1] * 0.15
                            + values[2] * 0.15
                            + values[3] * 0.15
                            + values[4] * 0.15
                            + values[5] * 0.25;
                    } else {
                        score = (values[0] + values[1] + values[2] + values[3] + values[4]) / 5;
                    }
                    vm.chartData = [values];
                    vm.chartColors = [getColorGraphByScore(score)];
                }
            }
            ctrl.$onInit = setData;
            ctrl.$onChanges = setData;
            var removeThemeListener = $rootScope.$on('suiteThemeChanged', setData);
            $scope.$on('$destroy', removeThemeListener);

            function getScoreByCategory(category) {
                if(!category){
                    return 0;
                }
                if(!isNaN(category)){
                    return parseInt(category);
                }
                if(category.score){
                    return parseInt(category.score);
                }
                return 0;
            }
            function getColorGraphByScore(score) {
                score = parseFloat(score);
                var greenColorHex = "#28b670";
                var orangeColorHex = "#fb8c00";
                var redColorHex = "#f44336";
            
                return score >= 75 ? greenColorHex :
                    score >= 50 ? orangeColorHex : redColorHex;
            }
            
        }]
    };
});
